/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Performancereport_Yourposition3Inputs */

const en_coinvestments_performancereport_yourposition3 = /** @type {(inputs: Coinvestments_Performancereport_Yourposition3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your position`)
};

/**
* | output |
* | --- |
* | "Your position" |
*
* @param {Coinvestments_Performancereport_Yourposition3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_performancereport_yourposition3 = /** @type {((inputs?: Coinvestments_Performancereport_Yourposition3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Performancereport_Yourposition3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_performancereport_yourposition3(inputs)
});
export { coinvestments_performancereport_yourposition3 as "coInvestments_performanceReport_yourPosition" }